module.exports = __webpack_public_path__ + "img/grupp-forfragningar.2cce40cc.jpg";